import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { BookOpen } from "lucide-react";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    const res = await register(name, email, password);
    setLoading(false);
    if (res.ok) navigate("/", { replace: true });
    else setError(res.error);
  };

  return (
    <div className="max-w-md mx-auto px-4 py-12" data-testid="register-page">
      <div className="border-2 border-[#09090b] bg-white p-8">
        <div className="flex items-center gap-2 mb-6">
          <img
            src="https://customer-assets.emergentagent.com/job_priya-book-platform/artifacts/j5n2tcp1_IMG_20211220_171122.jpg"
            alt="GAINA THE PRELUDE"
            className="w-10 h-10 rounded-full object-cover ring-2 ring-[#facc15]"
          />
          <div className="font-display font-black tracking-tight">GAINA THE PRELUDE</div>
        </div>
        <h1 className="font-display text-3xl font-black tracking-tight mb-2">Create your account</h1>
        <p className="text-sm text-[#52525b] mb-6">Free to join. Track orders, save cart, get bulk pricing.</p>
        <form onSubmit={submit} className="space-y-4">
          <label className="block">
            <div className="text-xs font-bold uppercase tracking-wider text-[#52525b] mb-1.5">Full Name</div>
            <input value={name} onChange={(e) => setName(e.target.value)} required data-testid="register-name-input" className="w-full border-2 border-[#e4e4e7] focus:border-[#ea580c] px-3 py-2.5 outline-none" />
          </label>
          <label className="block">
            <div className="text-xs font-bold uppercase tracking-wider text-[#52525b] mb-1.5">Email</div>
            <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="register-email-input" className="w-full border-2 border-[#e4e4e7] focus:border-[#ea580c] px-3 py-2.5 outline-none" />
          </label>
          <label className="block">
            <div className="text-xs font-bold uppercase tracking-wider text-[#52525b] mb-1.5">Password (min 8 chars)</div>
            <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required minLength={8} data-testid="register-password-input" className="w-full border-2 border-[#e4e4e7] focus:border-[#ea580c] px-3 py-2.5 outline-none" />
          </label>
          {error && <div className="text-sm text-[#dc2626] border border-[#dc2626] bg-[#fef2f2] px-3 py-2" data-testid="register-error">{error}</div>}
          <button type="submit" disabled={loading} className="w-full bg-[#ea580c] hover:bg-[#c2410c] disabled:opacity-60 text-white font-bold py-3" data-testid="register-submit-btn">
            {loading ? "Creating…" : "Create Account"}
          </button>
        </form>
        <div className="mt-6 text-sm text-center text-[#52525b]">
          Already have an account? <Link to="/login" className="font-bold text-[#ea580c] hover:underline">Sign in</Link>
        </div>
      </div>
    </div>
  );
}
